<template>
  <!-- zvonce: isto kao u javnom zaglavlju (raniji demo sadrzaj je u istoriji gita) -->
  <NotificationBell />
</template>

<script setup>
import NotificationBell from "~/components/notifications/NotificationBell.vue";
</script>
